import React, { Component } from 'react'
import { Button, Container, Row, Col, Form, Table, Navbar } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers'
import TextInput from 'react-autocomplete-input';

import Calendar from 'react-calendar'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
import axios from 'axios'

class FinancialWageSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Rice: {},
      target: '',
      targetObj: '',
      modalShow: false,
      savingText: false,
      isLoading: true,
    }
  }

  componentDidMount() {
    fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    }).then((data) => {
      this.setState({
        ...this.state,
        riceData: data,
        isLoading: false
      })

    })

    // setInterval(()=>{
    //   this.setState({
    //     ...this.state,
    //     savingText : !this.state.savingText
    //   })
    // },15000)
  }
  handleEditRiceTypeNameAndID(data) {
    console.log(data)
    let c = axios.post(
      'https://backend1.riceinspections.com/testGA',
      { data: data }
    )
      .then((res) => {
        alert('บันทึกเรียบร้อยแล้ว')
      }).catch((err) => {
        alert('เกิดข้อผิดพลาด')
      })
  }
  handleChangeRiceNameToRiceType(e, objName, fieldName) {
    this.setState({
      ...this.state,
      riceData: {
        ...this.state.riceData,
        [objName]: {
          ...this.state.riceData[objName],
          [fieldName]: e
        }
      }
    })
  }
  renderRiceType(riceData) {
    if (riceData) {
      return (
        Object.keys(riceData).map((a, idx) => {
          return <tr>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={riceData[a]['surveyNameTH']}
                  onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameTH') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={riceData[a]['surveyNameEN']}
                  onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameEN') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={riceData[a]['fare']}
                  onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'fare') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={riceData[a]['fare']}
                  onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'fare') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
          </tr> 
        })
      )
    }
  }
  showSaving() {
    if (this.state.savingText) {
      return 'Saving...'
    } else {
      return 'Saved 1 min ago.'
    }
  }
  goFinancialWageCalendar = () => {
    this.props.history.push({
      pathname: '/FinancialWageCalendar',
    })
  }

  render() {
    if (this.state.isLoading) {
      return (<Container>
        <AdminNav></AdminNav>
        <br></br>
        <Loading></Loading>

        </Container>)

    } else {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Navbar style={{ backgroundColor: '#F5F5F5' }} sticky="top" >
            <Container>
              <Button onClick={() => { this.goFinancialWageCalendar() }}> กลับไปยังหน้าค่าแรง </Button>
              <Navbar.Brand href="#">{
                // this.showSaving()
              } </Navbar.Brand>
              <Button onClick={() => { this.handleEditRiceTypeNameAndID(this.state.riceData) }}> save </Button>
            </Container>
          </Navbar>

          <Table bordered hover>
            <thead>
              {<tr><th>ชื่อสถานที่ภาษาไทย</th><th>ชื่อสถานที่ภาษาอังกฤษ</th><th>ค่าพาหนะ (บาท) </th></tr>}
            </thead>
            <tbody>
              {this.renderRiceType(this.state.riceData)}
            </tbody>
          </Table>
        </Container>
      );
    }

  }
}
export default withRouter(FinancialWageSetting)
